import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-patient-selection-dialog',
  templateUrl: './patient-selection-dialog.component.html',
  styleUrls: ['./patient-selection-dialog.component.scss']
})
export class PatientSelectionDialogComponent {
  patients: any[];
  filteredPatients: any[] = [];
  filterValue: string = '';

  constructor(
    public dialogRef: MatDialogRef<PatientSelectionDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.patients = _.uniqBy(data.patients?.filter((patient: any) => patient.active), 'id') || [];
    // Initialize filteredPatients with all patients on component initialization
    this.filteredPatients = [...this.patients];
  }

  clearFilters() {
    this.filterValue = '';
    this.applyFilter();
  }

  applyFilter() {
    if (!this.filterValue || this.filterValue.trim() === '') {
      this.filteredPatients = [...this.patients];
    } else {
      const filterTerms = this.filterValue.toLowerCase().split(' ');
      this.filteredPatients = this.patients.filter(patient => {

        const icdCodesMatch = patient.icdCodes?.some((icdCode: any) =>
          filterTerms.every(term =>
            _.includes((icdCode.code || '').toLowerCase(), term) ||
            _.includes((icdCode.description || '').toLowerCase(), term)
          )
        );

        const patientMatch = filterTerms.every(term =>
          _.includes(patient.name.toLowerCase(), term) ||
          _.includes(patient.surname.toLowerCase(), term) ||
          _.includes(patient.patientNumber?.toLowerCase(), term) ||
          _.includes(patient.diagnosis?.toLowerCase(), term)
        );

        return icdCodesMatch || patientMatch;
      });
    }
    this.sortPatientsByName();
  }

  sortPatientsByName() {
    this.filteredPatients = _.orderBy(this.filteredPatients, ['surname', 'name'], ['asc', 'asc']);
  }

  selectPatient(patient: any): void {
    this.dialogRef.close(patient);
  }

  addPatient(type: string) {
    this.dialogRef.close(type);
  }

  addEvent() {
    this.dialogRef.close('event');
  }
}
